<app-ods-modal>
  <p class="ods-modal__message">{{ message }}</p>

  <ng-container modalActions>
    <button mat-raised-button color="primary" (click)="onYesClick()" cdkFocusInitial>OK</button>
  </ng-container>
</app-ods-modal>
